/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */
import * as ApiService from 'common/services/ApiService';
import { SimplifiedDocumentSearchService } from 'common/services/SearchService';

export async function getPhotoMetadataByHashId(hashId) {
    const query = {
        filter: {
            fields: [
                'id',
                'hashId',
                'created',
                'refDocumentId',
                'refDocumentType',
            ],
            where: {
                and: [
                    { hashId },
                    { refDocumentId: { neq: null } },
                    { refId: { neq: null } },
                ],
            },
            order: ['created asc'],
        },
    };
    return ApiService.get(true, 'PhotoMetadata', query);
}

export async function getUsagePhotoByDocIds(ids) {
    const query = {
        filter: {
            field: ['documentTypeId', 'id', 'number', 'jobId', 'client'],
            include: [
                {
                    relation: 'property',
                },
                {
                    relation: 'job',
                },
            ],
            where: {
                id: { inq: [...ids] },
            },
            order: ['number asc'],
        },
    };
    return SimplifiedDocumentSearchService.find(query);
}
